import { db, extractCosyflowMeta } from "./db";
import axios from "axios";
import { getApiBaseUrl, getAuthorizationToken } from "./api-helper";
import pLimit from "p-limit";

const limit = pLimit(5); // max 5 requests at a time

async function updateSingleRecord(record) {
  if (!(record.data && record.data.title)) return;

  const modelTitle = record.data.title;
  console.log(`Updating model: ${modelTitle}`);

  try {
    // 🔹 Step 1: Capture old defaults
    const oldDefaults = {};
    if (record.data.variables) {
      for (const [key, obj] of Object.entries(record.data.variables)) {
        if (obj && typeof obj === "object" && "default" in obj) {
          const shortKey = key.includes(".") ? key.split(".")[1] : key;
          oldDefaults[shortKey] = obj.default;
        }
      }
    }

    const apiBase = await getApiBaseUrl();
    const response = await axios.get(
      `${apiBase}/api/cosyflows/query?title=${encodeURIComponent(modelTitle)}`,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getAuthorizationToken()}`
        }
      }
    );

    if (response.data.cosyflows && response.data.cosyflows.length > 0) {
      const cosyflow = response.data.cosyflows[0];
      if (cosyflow.cosyflow) {
        const newCosyflowData = typeof cosyflow.cosyflow === 'string'
          ? JSON.parse(cosyflow.cosyflow)
          : cosyflow.cosyflow;

        // 🔹 Step 2: Restore defaults
        if (newCosyflowData.variables) {
          for (const [key, obj] of Object.entries(newCosyflowData.variables)) {
            if (obj && typeof obj === "object" && "default" in obj) {
              const shortKey = key.includes(".") ? key.split(".")[1] : key;
              for (const [oldKey, oldDefault] of Object.entries(oldDefaults)) {
                if (shortKey === oldKey) {
                  obj.default = oldDefault;
                  break;
                }
              }
            }
          }
        }

        await db.cosyflows.update(record.id, {
          data: newCosyflowData,
          meta: extractCosyflowMeta(cosyflow),
          timestamp: Date.now()
        });

        console.log(`✅ Successfully updated model: ${modelTitle}`);
      }
    }
  } catch (error) {
    console.error(`❌ Failed to update model: ${modelTitle}`, error);
  }
}

export async function updateAllModels() {
  console.log("Starting model update process...");

  try {
    // Use more efficient query to get all records without loading into memory first
    const cosyflowRecords = [];
    await db.cosyflows.orderBy('id').each(record => {
      cosyflowRecords.push(record);
    });

    console.log(`Found ${cosyflowRecords.length} models to update.`);

    await Promise.all(
      cosyflowRecords.map(record =>
        limit(() => updateSingleRecord(record))
      )
    );

    console.log("✅ Model update process finished.");
  } catch (error) {
    console.error("❌ Failed to retrieve models from IndexedDB.", error);
  }
}
